import React from 'react';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { Helmet } from "react-helmet";
import PageNotAllowed from "../../components/errors/PageNotAllowed";
import ClientProvider from "../../providers/ClientProvider";

const SupplierLayout = props => {

    const { auth, appropriate, isLoading } = useAuth();
    const { pathname } = useLocation();

    if (!auth || !auth.supplierOrg?.() || !auth.canManageClientResourceTalent()) {
        return <PageNotAllowed />
    }

    if (
        auth && (!auth.supplierOrg?.()?.hasCompletedSupplierProfile()
            || !auth.supplierOrg?.()?.total_supplied_talent_users)
        && !pathname?.includes('manage-profile')
    ) {
        let redirect = !auth.supplierOrg?.()?.hasCompletedSupplierProfile() ? 'about' : 'talent-resources';
        return <Navigate to={`/supplier/manage-profile/${redirect}`} replace={true} />
    }

    const pageTitle = () => {
        if (pathname.includes('supplier/contracts')) {
            return 'Contracts | Supplier'
        } else if (pathname.includes('supplier/job-board')) {
            return 'Job Board | Supplier'
        } else if (pathname.includes('supplier/teams')) {
            return 'Teams | Supplier'
        } else if (pathname.includes('supplier/projects')) {
            return 'Projects | Supplier'
        }
        return 'Supplier'
    }

    return (
        <ClientProvider>
            <Helmet>
                <title>{pageTitle()} | Wripple</title>
            </Helmet>
            <Outlet />
        </ClientProvider>
    );
};

SupplierLayout.propTypes = {

};

export default SupplierLayout;